// Routing
import { Outlet } from "react-router-dom";
// Styles
import Styles from "./styles.module.scss";
// Components
import Header from "../Header";
import FooterV2 from "components/NewDesignComponents/FooterV2";
import { useRef } from "react";
import { detectDevice, launchAppOrFallback } from "utils";
import { sendConversion } from "components/TagManagers/GoogleTagManager";
import { APP_STORE_URL } from "constants/index";

const Main = ({
  footer,
  header,
  consultButton,
  navigateTo,
  hideGetStarted,
  hideSchoolNav,
  hideSignIn,
  languageBlockDisplayMediaQuery,
}) => {
  const journeySectionRef = useRef(null);

  const handleHeroCta = () => {
    sendConversion("book_free_consultation");
    const { platform } = detectDevice();

    if (platform === "ios") {
      launchAppOrFallback({
        deepLink: "numuw://",
        fallbackUrl: APP_STORE_URL,
      });
      return;
    }

    if (platform === "android") {
      launchAppOrFallback({
        deepLink: "numuw://",
        fallbackUrl: APP_STORE_URL,
      });
      return;
    }

    journeySectionRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className={Styles.container}>
      <Header
        navigateTo={navigateTo}
        header={header}
        consultButton={consultButton}
        hideSchoolNav={hideSchoolNav}
        hideSignIn={hideSignIn}
        languageBlockDisplayMediaQuery={languageBlockDisplayMediaQuery}
        onPrimaryCtaClick={handleHeroCta}
      />
      {/* <LanguageBlock /> */}
      <main className={Styles.main_content}>
        <Outlet
          context={{ journeySectionRef, onPrimaryCtaClick: handleHeroCta }}
        />
      </main>
      <div style={{ width: "100%", background: "#F4F3FC" }}>
        {/* {footer && <Footer hideGetStarted={hideGetStarted} />} */}
        {footer && (
          <FooterV2
            hideGetStarted={hideGetStarted}
            onPrimaryCtaClick={handleHeroCta}
          />
        )}
      </div>
    </div>
  );
};

export default Main;
